/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Createdutc3Inputs */

const en_entity_createdutc3 = /** @type {(inputs: Entity_Createdutc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created (UTC)`)
};

const de_entity_createdutc3 = /** @type {(inputs: Entity_Createdutc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt (UTC)`)
};

/**
* | output |
* | --- |
* | "Created (UTC)" |
*
* @param {Entity_Createdutc3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_createdutc3 = /** @type {((inputs?: Entity_Createdutc3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Createdutc3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_createdutc3(inputs)
	return de_entity_createdutc3(inputs)
});
export { entity_createdutc3 as "entity_createdUTC" }